import Image from "next/image";
import 섹션1_이미지1 from "/public/assets/mobile/images/pic/img_marketbom_section1.webp";
import 섹션2_이미지1 from "/public/assets/mobile/images/pic/img_franchise_section1.webp";
import 섹션2_이미지2 from "/public/assets/mobile/images/pic/img_franchise_section2.webp";
import 섹션2_이미지3 from "/public/assets/mobile/images/pic/img_franchise_section3.webp";
import 섹션2_이미지4 from "/public/assets/mobile/images/pic/img_franchise_section4.webp";
import 섹션2_이미지5 from "/public/assets/mobile/images/pic/img_franchise_section5.webp";
import 섹션2_이미지6 from "/public/assets/mobile/images/pic/img_franchise_section6.webp";
import { 프랜차이즈_목록_Mobile } from "./프랜차이즈_목록_Mobile";
import { 랜딩_섹션2_Mobile } from "./랜딩_섹션2_Mobile";
import { 푸터_Mobile } from "./푸터_Mobile";
import Link from "next/link";
import 화살표_아이콘 from "/public/assets/mobile/images/icon/icon_move_link1.svg";
import { 링크 } from "./데이터/링크";
import { useTracker } from "./util/Tracker";
import { 헤더_MobileAB } from "./헤더_MobileAB";
import { useContext } from "react";
import { GrowthBookCTX, getValue } from "./util/GrowthBookCTX";
import { pipe } from "@mobily/ts-belt";

export const 프랜차이즈_Mobile = () => {
  const tracker = useTracker();
  const featureFlag = useContext(GrowthBookCTX);
  const simplifiedRegister = pipe(featureFlag, getValue("simplified-register"));

  return (
    <>
      <div id="wrap">
        <헤더_MobileAB />

        <div id="container" className="service-infomation service-marketbom">
          <h2 className="blind">본문 내용</h2>

          <div
            className="section section1"
            style={{
              background: `url(${섹션1_이미지1.src}) no-repeat center center`,
              backgroundSize: "100%",
            }}
          >
            <dl>
              <dt><span style={{ fontWeight: 400 }}>프랜차이즈 전용</span><br/>수발주 프로그램</dt>
              <dd>
                마켓봄은 2,000여 개의 프랜차이즈 본사가<br/>
                사용하고 있습니다.
              </dd>
            </dl>
          </div>

          <div className="section section2">
            <h3>아직도 이런 문제를 가지고 계신가요?</h3>

            <div className="shadow-box type1">
              <dl>
                <dt>
                  카톡, 문자, 전화로 <strong className="bold">불편한 주문</strong>
                  <br />
                  <span className="fc1">
                    가맹점 전용 주문앱으로 <strong className="bold">간단하게 주문</strong>
                  </span>
                </dt>
                <dd>
                  상품 이미지를 보고 장바구니에 담아<br/>
                  주문 하는 방식으로 가맹점주님들의<br/>
                  <strong className="bold">교육이 필요하지 않습니다.</strong>
                </dd>
              </dl>
              <Image src={섹션2_이미지1} alt="" priority />
            </div>
            <div className="shadow-box type2">
              <dl>
                <dt>
                  외상 거래로 <strong className="bold">미수금 증가</strong>
                  <br />
                  <span className="fc1">
                    선결제 방식으로 <strong className="bold">미수금 ZERO!</strong>
                  </span>
                </dt>
                <dd>
                  가상계좌와 신용카드를 이용한 선결제 방식으로<br />
                  <strong className="bold">미수금 없이 본사 운영이 가능</strong>합니다.<br />
                  선결제가 불가할 경우 한도설정과<br/>
                  알림서비스로 외상거래를 최소화할 수 있습니다.
                </dd>
              </dl>
              <Image src={섹션2_이미지2} alt="" />
            </div>
            <div className="shadow-box type3">
              <dl>
                <dt>
                  오래걸리는 <strong className="bold">매입처별 주문 전달</strong>
                  <br />
                  <span className="fc1">
                    자동 발주로 <strong className="bold">주문 마감과 동시에</strong>
                    <br/>
                    <strong className="bold">자동 전달</strong>
                  </span>
                </dt>
                <dd>
                  매입처별 주문내역을 취합할 필요없이 마감시간에<br/>
                  <strong className="bold">자동으로 문자가 발송</strong>됩니다.
                </dd>
              </dl>
              <Image src={섹션2_이미지3} alt="" />
            </div>
            <div className="shadow-box type4">
              <dl>
                <dt>
                  <strong className="bold">엑셀로 작업</strong>하는 매출분석
                  <br />
                  <span className="fc1">
                    담당자 지정으로 <strong className="bold">원클릭 분석</strong>
                  </span>
                </dt>
                <dd>
                  가맹점별 영업담당자, 배송담당자, 5단계 카테고리<br />
                  설정 등 <strong className="bold">여러 방법으로 매출분석이 가능</strong>합니다.
                </dd>
              </dl>
              <Image src={섹션2_이미지4} alt="" />
            </div>
            <div className="shadow-box type5">
              <dl>
                <dt>
                  <strong className="bold">매번 누락</strong>되는 공지사항
                  <br />
                  <span className="fc1">
                    모든 가맹점에 <strong className="bold">누락없이 한번에!</strong>
                  </span>
                </dt>
                <dd>
                  카톡, 문자가 아닌 가맹점 전용 앱을 통한 공지로<br />
                  <strong className="bold">모든 가맹점에 누락없이 공지</strong>가 가능합니다.
                </dd>
              </dl>
              <Image src={섹션2_이미지5} alt="" />
            </div>
            <div className="shadow-box type6">
              <dl>
                <dt>
                  <strong className="bold">사무실에서만</strong> 해야하는 업무!
                  <br />
                  <span className="fc1">
                    설치 없이 <strong className="bold">언제 어디서나 접속</strong>
                  </span>
                </dt>
                <dd>
                  인터넷이 가능한 공간이면<br />
                  <strong className="bold">언제 어디서든 업무가 가능</strong>합니다.
                </dd>
              </dl>
              <Image src={섹션2_이미지6} alt="" style={{paddingBottom: "20px"}} />
            </div>
          </div>
          <div id="container" className="main">
            <프랜차이즈_목록_Mobile inline={true} />
          </div>
          <div className="section section3">
            <div style={{textAlign: "center", fontSize: "22px", lineHeight: "28px", fontWeight: 700}}>프랜차이즈 대표님 인터뷰</div>
            <랜딩_섹션2_Mobile interviewOnly={true} />
            <Link
              href={
                simplifiedRegister
                  ? 링크.마켓봄_간편가입_실험_링크_PC
                  : 링크.마켓봄_회원가입
              }
              className="btn-start-nomargin"
              style={{
                background: `url(${화살표_아이콘.src}) no-repeat right 30px center #fe6b37`,
              }}
              onClick={() =>
                tracker.trackingClick({
                  depth1: "MARKETBOM",
                  depth2: "회원가입",
                  depth3: "마켓봄",
                  indicator: "회원가입",
                })
              }
            >
              <strong>마켓봄 가입하고 상담받기</strong>
            </Link>
          </div>
        </div>

        <푸터_Mobile />
      </div>
    </>
  );
};
